<script setup lang="ts">
import MenuListItem from "@/components/ui/MenuList/MenuListItem.vue";
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";

const emit = defineEmits<{ select: [user: null] }>();
</script>

<template>
  <MenuListItem @click="emit('select', null)">
    <template #before>
      <div class="unassign-container">
        <SvgIcon name="persona/no-user" width="20" height="20" />
      </div>
    </template>
    <span>{{ $t("general.unassigned") }}</span>
  </MenuListItem>
</template>
